$(function () {
    $('.nyttehaveQueueForm').on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var data = $(e.target).serialize();
        $.post('/account/addtoqueue', data, (data, textStatus, xhr) => {
            var responseJson = xhr.responseJSON;
            swal.fire({
                title: responseJson.title,
                text: responseJson.message,
                icon: 'success'
            });
        }).fail((xhr: JQueryXHR) => {
            var responseJson = xhr.responseJSON;
            swal.fire({
                title: responseJson.title,
                text: responseJson.message,
                icon: 'warning'
            });
        });
    });
});